import { render, staticRenderFns } from "./VersionVulnerabilities.vue?vue&type=template&id=a19c9aee&"
import script from "./VersionVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./VersionVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports